import { ProductType, TYPE_JEWELRY } from '../constants/productTypes';

import Product from './Product';

export default class Jewelry extends Product {
  declare entityType: ProductType;

  constructor(...args: ConstructorParameters<typeof Product>) {
    super(...args);

    this.entityType = TYPE_JEWELRY;
  }
}
